export default function (date) {
    var result = new Date(date);
    result.setDate(result.getDate() + 1);
    return result;
}